import serverVars from 'server-vars';
import { isBot } from './botTypeHelpers';

export const getIsBotOnClient = (): boolean => isBot(serverVars.get('botType'));
